import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig, ActiveToast } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class Toastr {
	constructor(private translateService: TranslateService,
							private toastrService: ToastrService) {}

	error(msgKey: string, interpolateParams?: Object, config?: Partial<IndividualConfig>): ActiveToast<any> {
		return this.toastrService.error(this.translate( msgKey, interpolateParams ), this.translate( 'error' ), config)
	}

	rawError(message: string, config?: Partial<IndividualConfig>): ActiveToast<any> {
		return this.toastrService.error( message, this.translate( 'error' ), config)
	}

	show(msgKey?: string, title?: string, override?: Partial<IndividualConfig>, type?: string): ActiveToast<any> {
		return this.toastrService.show(this.translate(msgKey), this.translate(title), override, type);
	}

	success(msgKey?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
		return this.toastrService.success(this.translate(msgKey), this.translate(title), override);
	}

	info(msgKey?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
		return this.toastrService.info(this.translate(msgKey), this.translate(title), override);
	}

	rawInfo(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
		return this.toastrService.info(message, this.translate(title), override);
	}

	warning(msgKey?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
		return this.toastrService.warning(this.translate(msgKey), this.translate(title), override);
	}

	clear(toastId?: number): void {
		this.toastrService.clear(toastId);
	}

	remove(toastId: number): boolean {
		return this.toastrService.remove(toastId);
	}

	translate(txt: string, interpolateParams?: Object): string {
		return this.translateService.instant(txt, interpolateParams);
	}
}